<template>
    <div class="lender-box">
        <nuxt-link
            :to="$prismic.linkResolver(lenderWithModel)"
            class="lender-box__inner"
        >
            <PrismicImage
                :img="lenderWithModel.data.image"
                :alt="lenderWithModel.data.title"
                w="100"
                h="50"
            />  
        </nuxt-link>

        <div
            class="payout-info"
        >
            <span>{{ $translate('estimated_payout_time', 'Förväntad utbetalning inom {payout}')
                .replace('{payout}', payoutSpeedString) }}</span>
        </div>

        <div
            class="payout-date"
        >
            <span>{{ payoutDateDayString }}</span>
            <span>{{ payoutDateTimeString }}</span>
        </div>

        <div class="lender-box__inner">
            <ButtonTarget
                size="sm"
                background="green"
                :text="$translate('cta_to_application', 'Till ansökan')"
                :link="lenderWithModel"
                placement="rich-text-lender-box"
            />
        </div>
    </div>
</template>

<script>
import PayoutTime from '@/mixins/PayoutTime';
export default {
    mixins: [PayoutTime],
    props: {
        lenderWithModel: {
            type: Object,
            required: true
        },
    },
    computed: {
        model() {
            return this.lenderWithModel.model;
        }
    }
};
</script>

<style lang="scss" scoped>
.lender-box {
    @include border;
    box-shadow: $bxs;
    @include border-radius(5px);
    @include spacing(padding, 4);
    @include grid(1, 30px);
    width: 100%;
    color: $font;

    @include device(pad) {
        @include grid(4, 10px);
    }

    .lender-box__inner {
        @include grid(1, 10px);
        text-align: center;

        &:first-child {
            @include flex;
        }

        span {
            font-size: 14px;
            &:last-child { font-weight: bold; }
        }

        a {
            @include flex;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        img { @include size(100px, auto); }
    }

    .payout-info {
        font-size: 14px;
    }
    
    .payout-date {
        font-size: 14px;
        background: $lightgray;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 3px;

        span:first-child {
            font-weight: bold;
        }
        span:first-letter {
            text-transform: uppercase;
        }
    }
}
</style>
